export default __webpack_public_path__ + "images/logoAromatherapy.0ad7c094fb164e5ab25cc4c0872f65d2.svg"